import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { setting } from '../../../setting';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()

export class HomeService {
	public authApiUrl: string;
	public apiBookingUrl  : string;
	constructor(private _http: HttpClient) {
		this.authApiUrl = setting.authApiUrl;
		this.apiBookingUrl  = setting.apiBookingUrl
	}

  	getConsultUpdatedClient() {
		let params: HttpParams = new HttpParams();
		params = params.set('name', setting.name);
		return this._http.get(this.authApiUrl + 'clients-updates', { params: params });
	}

	getClientsSettingAppAuth() {
		let params: HttpParams = new HttpParams();
		params = params.set('name', setting.name);
		return this._http.get(this.authApiUrl + 'getClientsSettingAppAuth', { params: params });
	}

  public getCountriesData(): Observable<any> {
    return this._http.get<any>(`${this.apiBookingUrl}utilities/countries`).
    pipe(map(res => res.Countrys));
  }

  public getDestinationsData(countryId: string): Observable<any> {
    return this._http.get<any>(`${this.apiBookingUrl}utilities/destinations/${countryId}`).
    pipe(map(res => res.destinations));
  }

  public getCitiesData(destinationId: string): Observable<any> {
    return this._http.get<any>(`${this.apiBookingUrl}utilities/cities/${destinationId}`).
    pipe(map(res => res.cities));
  }

  public getLocationAgency(): Observable<any[]> {
    return this._http.get<any[]>(`${this.apiBookingUrl}locationAgency`);
  }

  public getPositionAgency(): Observable<any[]> {
    return this._http.get<any[]>(`${this.apiBookingUrl}positionEnterprise`);
  }
}
